import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./wrapper.module.css";
var Wrapper = function(_param) {
    var children = _param.children, isFullHeight = _param.isFullHeight, isFluid = _param.isFluid, isSlim = _param.isSlim, hasOverflow = _param.hasOverflow, className = _param.className, _backgroundColor = _param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, rest = _object_without_properties(_param, [
        "children",
        "isFullHeight",
        "isFluid",
        "isSlim",
        "hasOverflow",
        "className",
        "backgroundColor"
    ]);
    var _obj;
    var classNames = cx(styles.wrapper, (_obj = {}, _define_property(_obj, styles.container, !isFluid), _define_property(_obj, styles.wrapperFullHeight, isFullHeight), _define_property(_obj, styles.slimContainer, !isFluid && isSlim), _define_property(_obj, styles.wrapperOverflow, !hasOverflow), _obj), className === null || className === void 0 ? void 0 : className.inner);
    return /*#__PURE__*/ _jsx("section", {
        className: className === null || className === void 0 ? void 0 : className.container,
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
            className: classNames
        }, rest), {
            children: children
        }))
    });
};
export default Wrapper;
